<template>
  <header>
    <nav
      class="flex flex-wrap items-center justify-between w-full py-0 md:py-0 px-1 lg:px-4 text-base text-green-100 font-bold transition duration-500 ease-in-out lg:fixed top-0 border-green-100 border-b-4"
      :style="{
        borderColor: colors.green,
        zIndex: 999,
        background: colors.bgLight,
      }"
    >
      <div
        class="inner-container px-0 w-full flex justify-center items-center lg:justify-start lg:items-center flex-col lg:flex-row"
      >
        <div
          class="flex items-center justify-center lg:justify-start lg:items-start w-full lg:w-auto"
        >
          <landing-logo
            style="max-width: 375px !important"
            :company-name="companyName"
            class="lg:mr-6"
          />

          <a
            class="absolute right-4 sm:hidden cursor-pointer"
            @click="toggleMenu"
            ><Menu
          /></a>
        </div>

        <transition name="fade">
          <div
            class="w-full sm:flex md:items-center"
            :class="isMenuShown ? 'flex' : 'hidden'"
          >
            <ul
              class="w-full mb-4 px-4 sm:px-0 lg:mb-0 text-sm sm:flex sm:justify-between sm:items-center sm:pt-0"
            >
              <nav-item
                v-for="item in navItems"
                :key="item.url"
                :text="item.text"
                :url="item.url"
              />

              <li>
                <LanguageSwitcher />
              </li>

              <li class="flex items-center">
                <n-button
                  class="mt-2 sm:mt-0 sm:ml-2 xl:ml-4"
                  variant="white"
                  container-classes="py-2"
                  :style="{
                    background: `${colors.ctaButtonSecondary}!important`,
                    color: '#fff!important',
                    paddingTop: '7px!important',
                    paddingBottom: '7px!important',
                  }"
                  rounded-xxl
                  @click="$emit('cta')"
                >
                  {{ $t("DRCOG.get-nymbl") }}
                </n-button>
              </li>
            </ul>
          </div>
        </transition>
      </div>
      <landing-horizontal-line :color="colors.line" />
    </nav>
  </header>
</template>

<script setup>
import { ref, computed } from "vue";
import LandingLogo from "../LandingLogo.vue";
import NavItem from "../NavItem.vue";
import LandingHorizontalLine from "../LandingHorizontalLine.vue";
import Menu from "vue-material-design-icons/Menu.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

import { useI18n } from "vue-i18n";

const { t } = useI18n();

const isMenuShown = ref(false);

const toggleMenu = () => {
  isMenuShown.value = !isMenuShown.value;
};

const navItems = computed(() => [
  {
    text: t("DRCOG.about-nymbl"),
    url: "#about",
  },
  {
    text: t("DRCOG.testimonials"),
    url: "#testimonials",
  },
  {
    text: t("DRCOG.why-nymbl"),
    url: "#why",
  },
  {
    text: t("DRCOG.community-partners"),
    url: "#partners",
  },
  {
    text: t("DRCOG.faq"),
    url: "#faq",
  },
]);

defineProps({
  companyName: {
    type: String,
    required: true,
  },
  colors: {
    type: Object,
    required: true,
  },
});

defineEmits(["cta"]);
</script>
